import { Base64 } from 'js-base64';
function storageSetItem(key, value) {
  if (value === undefined || value === null) {
    return;
  }
  let json = JSON.stringify(value);
  json = Array.from(json).map(char => char.charCodeAt(0)).reverse().join('|');
  window.localStorage.setItem(key, Base64.encode(json));
}
function storageGetItem(key) {
  const storedValue = window.localStorage.getItem(key);
  if (storedValue !== null) {
    const value = Base64.decode(storedValue).split('|').map(char => Number.parseInt(char, 10)).reverse().map(charCode => String.fromCharCode(charCode)).join('');
    try {
      return JSON.parse(value);
    } catch (err) {
      return null;
    }
  } else {
    return null;
  }
}
function storageUpdateItem(key, value) {
  const oldValue = storageGetItem(key);
  if (oldValue && typeof oldValue === 'object' && value && typeof value === 'object') {
    value = Object.assign({}, oldValue, value);
  }
  let json = JSON.stringify(value);
  json = Array.from(json).map(char => char.charCodeAt(0)).reverse().join('|');
  window.localStorage.setItem(key, Base64.encode(json));
}
function storageRemoveItem(key) {
  window.localStorage.removeItem(key);
}
function storageClear() {
  window.localStorage.clear();
}
export { storageSetItem, storageGetItem, storageUpdateItem, storageRemoveItem, storageClear };